import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';

const Expenses = () => {
    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const [ExpenseName, setExpenseName] = useState('');
    const [ExpenseId, setExpenseId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [rows, setRows] = useState([]);


    const headers = apiHeadersJson;
    const toast = useRef(null);

    const HandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const body = {
            expense_name: ExpenseName,
            expense_id: ExpenseId,
            store_id: store_id,
        };

        try {
            const response = await axios.post(`${apiUrl}/Masters/CreateExpense`, body, { headers });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetExpenseList`, { params: { keyword, store_id: store_id }, headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const handleResetForm = () => {
        setExpenseId(null);
        setExpenseName('');
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Expense?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeleteBrand(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeleteBrand = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Masters/DeleteExpense`, { params: { expense_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const GetInfo = async (id) => {
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetExpenseInfo`, { params: { expense_id: id }, headers })
            const { success, data, message } = response.data;
            if (success) {
                setExpenseId(data[0].expense_id);
                setExpenseName(data[0].expense_name);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000, });
            }
        } catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (keyword) {
                GetList();
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    useEffect(() => {
        GetList();
    }, [store_id]);

    useEffect(() => {
        store_id && handleResetForm();
    }, [store_id]);

    const ActionBody = (data) => {
        return (
            <>
                <Button icon="pi pi-pencil" outlined onClick={() => GetInfo(data.expense_id)} />
                <Button outlined className='ms-3' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.expense_id)} />
            </>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="main-heading">
                        <h6>Expense</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Expense</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-4">
                        <div className="card">
                            <h4 className="bg-dark text-white rounded-top p-3">Expense</h4>
                            <form className='p-3' onSubmit={HandleSubmit}>
                                <div className="row">
                                    <div className="my-3">
                                        <label className="form-label">Expense Name</label>
                                        <input
                                            type="text"
                                            value={ExpenseName}
                                            className="form-control"
                                            onChange={(e) => setExpenseName(e.target.value)}
                                            required={true}
                                            placeholder='Enter Expense Name'
                                        />
                                    </div>
                                </div>
                                {!ExpenseId && <Button
                                    type="submit"
                                    label={loading ? "Loading..." : "Submit"}
                                    className="btn btn-success mt-3"
                                    disabled={loading || !ExpenseName || !store_id}
                                />}
                                {ExpenseId &&
                                    <div>
                                        <Button
                                            type="submit"
                                            label={loading ? "Loading..." : "Update"}
                                            className="btn btn-success mt-3"
                                            disabled={loading || !ExpenseName || !store_id}
                                        />
                                        <Button
                                            type="button"
                                            onClick={handleResetForm}
                                            label={loading ? "Loading..." : "Reset"}
                                            className="btn btn-light mt-3 float-end"
                                            disabled={loading}
                                        />
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8 mt-4">
                        <div className="card">
                            <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                                <h4 className="text-white">Expense List</h4>
                                <IconField iconPosition="left" style={{ width: '35%' }}>
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText
                                        className='w-100'
                                        onChange={(e) => setKeyword(e.target.value)}
                                        placeholder='Search By Expense Name...' />
                                </IconField>
                            </div>
                            {dataTableLoading ? (
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                    <Skeleton shape='rectangle' width="100%" height="40px" className="mb-1" />
                                ))
                            ) : (
                                <DataTable value={rows} paginator rows={10} rowsPerPageOptions={[10, 20, 30]}>
                                    <Column field='store_name' header='Store Name' />
                                    <Column field='expense_name' header='Expense Name' />
                                    <Column body={ActionBody} header='Action' />
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Expenses;
